module.exports = __webpack_public_path__ + "static/media/brand_logo1.d06aef7e.jpg";